// const getColor = (colorName) => {
//   switch(colorName) {
//     case 'black':
//       return '#444444'
//     case 'gelb':
//       return '#f2d024'
//     case 'aqua':
//       return '#64d5ca'
//     case 'orange':
//       return 'rgb(245, 156, 0)' //git add 'rgb(223,168,39)'
//     case 'erikaviolett':
//       return '#de4c8a'
//     case 'blau':
//       return 'rgb(66, 134, 244)'
//     case 'blauNase': 
//       return '#6ca3fc'
//     case 'grün':
//       return '#38c172'
//     case 'grünNase':
//       return '#70d89c'
//     case 'beige':
//       return '#dcdcc6'
//     case 'Metall:':
//     case 'Metall':
//       return '#ababab'
//     case 'schwarz':
//       return 'black'
//     case 'schwarzNase':
//       return '#353535'
//     case 'rot':
//       return '#d1230c'
//     case 'weiß': 
//       return '#f9f9f9'
//     case 'grau':
//       return '#ababab'

//     default:
//       return '#9b9b9b'
//   }
// }

// export { getColor }

module.exports = {
  'black': '#444',
  'yellow': '#f2d024',
  'gelb': '#f2d024',
  'aqua': '#64d5ca',
  'orange': 'rgb(245, 156, 0)',
  'erikaviolet': '#de4c8a',
  'erikaviolett': '#de4c8a',
  'blue': 'rgb(66, 134, 244)',
  'blau': 'dodgerblue',
  'beige': '#dcdcc6',
  'metal': '#ababab',
  'Metall': '#ababab',
  'red': '#d1230c',
  'rot': '#d1230c',
  'white': '#f9f9f9',
  'weiß': '#f9f9f9',
  'grey': '#ababab',
  'green': '#38c172',
  // 'grün': '#38c172',
  'grün': '#00a900',
  'schwarz': '#444',
  'default': '#9b9b9b',
  'Kupfer': 'black',
  'Aluminium M32': 'lightgrey',
  'limonengrün': '#00a900'
}